// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__dgCCX","large":"Button_large__2WdYn","small":"Button_small__2gjkf","default":"Button_default__1fIO7","error":"Button_error__3Np7c"};